export default () => ({
  router: 'null'
})
